<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Bill Of Lading </b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-button
                size="sm"
                variant="danger"
                id="DLoader"
                v-if="billLandingModel.blLandingId!='' && billLandingModel.blType=='HouseBL'"
                @click="deleteAllBL"
              >Delete B/L</b-button>-->
              <b-button
                size="sm"
                style="margin-left: 5px"
                v-if="
                  billLandingModel.blLandingId != '' &&
                  billLandingModel.blType == 'LinerBL'
                "
                :disabled="!billLandingModel.blLandingId? true: false"
                variant="warning"
                class="pull-right"
                id="addButtonLoader"
                @click="proceedToTally"
                >Proceed To Invoice</b-button
              >
              
              
              <b-button
                v-if="
                  billLandingModel.blLandingId != '' &&
                  billLandingModel.blType == 'LinerBL' &&
                  billLandingModel.billingType!='1'
                "
                :disabled="!billLandingModel.blLandingId? true: false"
                @click="sendMANIFESTATION(billLandingModel)"
                size="sm"
                variant="warning"
                style="margin-left: 5px"
                >SEND MANIFESTATION</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
        v-if="ALLMODULE"
          :allModuleIdBanner="ALLMODULE ? ALLMODULE : ''"
          :jobSeriesBanner="JOBSERIES ? JOBSERIES : ''"
          :bannerClientName="
            finalPlaceUSNONUS.length > 0 ? finalPlaceUSNONUS[0].clientName : ''
          "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <div class="mt-3">
              <b-button
                size="sm"

                variant="outline-dark"
                @click="showMoreItem"
              >{{showMoreNewItem==true?"Hide Container Details":"Show Container Details"}}</b-button>
             </div> -->
            <div class="mt-2" v-if="showMoreNewItem == true">
              <!-- <b-card class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{finalPlaceUSNONUS[0].clientName}}
                          <br>
                        </b>
                        <b>
                          Assignment No. : {{finalPlaceUSNONUS[0].ffExportFclSeries}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <b>
                          FF Activity : {{finalPlaceUSNONUS[0].containerInfo}}
                          <br>
                        </b>
                        <b>
                          Stuffing Type : {{finalPlaceUSNONUS[0].stuffingType}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{finalPlaceUSNONUS[0].shippingLine}}</b>
                       
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card> -->

              <table
                v-if="containerTypeDetailFactory.length > 0"
                id="ffContainer"
                class="table table-bordered"
              >
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Container No.</th>
                    <th>Container Type</th>
                    <th>Custom Seal No</th>
                    <th>Line Seal No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in containerTypeDetailFactory" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td @click="viewEdit(item.ffExecutionContainerId, index)">
                      {{ item.containerNo }}
                    </td>

                    <td>{{ item.containerType }}</td>
                    <td>{{ item.customSealNo }}</td>
                    <td>{{ item.LineSealNo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div>
              <!-- {{billLandingModel.ffExportFclId}}
              {{FreightExportFCL.allModuleId}} -->

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="50">
                  <label for="blType">B/L Type *</label>
                  <model-list-select
                    :list="blTypeList"
                    v-model="billLandingModel.blType"
                    option-value="blTypeVal"
                    option-text="blTypeTxt"
                    placeholder="Select B/L Type"
                    :isDisabled="
                      billLandingModel.blLandingId != '' &&
                      $sessionsStorage.get('designation') != 'Admin'
                        ? true
                        : false
                    "
                    @input="formalBL(billLandingModel.blType)"
                  ></model-list-select>
                  <span class="error" v-if="!billLandingModel.blType">{{
                    errorVgmList.blType
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="45" v-if="billLandingModel.blType == 'HouseBL'">
                  <label for="billingParty">B/L Format</label>
                  <model-list-select
                    :isDisabled="billLandingModel.blLandingId != '' ? true : false"
                    :list="BLListType"
                    v-model="billLandingModel.typeOfBL"
                    option-value="val"
                    option-text="type"
                    placeholder="Select Bill  Type"
                    @searchchange="formalBL(billLandingModel.typeOfBL)"
                    @input="formalBL(billLandingModel.typeOfBL)"
                  ></model-list-select>
                  <!-- <span class="error" v-if="!billLandingModel.typeOfBL">{{errorVgmList.typeOfBL}}</span> -->
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="50" v-if="billLandingModel.blType == 'HouseBL'">
                  <label for="frghtTermsHbl">Freight Terms for HBL</label>
                  <model-list-select
                    :list="frghtTermsHblList"
                    v-model="billLandingModel.frghtTermsHbl"
                    option-value="frghtTermsHblVal"
                    option-text="frghtTermsHblTxt"
                    placeholder="Select Freight Terms for HBL"
                    @input="formalBL(billLandingModel.frghtTermsHbl)"
                  ></model-list-select>
                  <span class="error" v-if="!billLandingModel.frghtTermsHbl">{{
                    errorTermList.frghtTermsHbl
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="45" v-if="billLandingModel.blType == 'HouseBL'">
                  <label for="frghtTermsMbl">Freight Terms for MBL</label>
                  <model-list-select
                    :list="frghtTermsMblList"
                    v-model="billLandingModel.frghtTermsMbl"
                    option-value="frghtTermsMblVal"
                    option-text="frghtTermsMblTxt"
                    placeholder="Select Freight Terms for MBL"
                    @input="formalBL(billLandingModel.frghtTermsMbl)"
                  ></model-list-select>
                  <span class="error" v-if="!billLandingModel.frghtTermsMbl">{{
                    errorTermList.frghtTermsMbl
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="50" v-if="billLandingModel.blType == 'LinerBL'">
                  <label for="frghtTermsLiner">Liner Freight Terms</label>
                  <model-list-select
                    :list="frghtTermsLinerListName"
                    v-model="billLandingModel.frghtTermsLiner"
                    option-value="frghtTermsLinerVal"
                    option-text="frghtTermsLinerTxt"
                    placeholder="Select Freght Terms"
                    @input="formalBL(billLandingModel.frghtTermsLiner)"
                  ></model-list-select>
                  <span class="error" v-if="!billLandingModel.frghtTermsLiner">{{
                    errorLTermList.frghtTermsLiner
                  }}</span>
                </md-layout>
                <md-layout
                  md-flex="5"
                  v-if="billLandingModel.blType == 'LinerBL'"
                ></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Master B/L Number</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="linerBLNumber"
                      name="linerBLNumber"
                      v-model="billLandingModel.linerBLNumber"
                      @input="formalBL(billLandingModel.linerBLNumber)"
                    ></b-form-input>
                    <span class="error" v-if="!billLandingModel.linerBLNumber">{{
                      errorLTermList.linerBLNumber
                    }}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="20">
                  <b-button
                    size="sm"
                    style="margin-top: 35px !important"
                    @click="showDocModal"
                    variant="dark"
                    >Upload
                    {{ billLandingModel.blType == "LinerBL" ? "Liner " : "Master " }}
                    BL</b-button
                  >

                  <!-- <md-input-container>
                    <label>Upload Liner B/L</label>
                    <md-file
                      name="linerBLupload"
                      id="linerBLupload"
                      v-model="billLandingModel.linerBLupload"
                      @selected="onFileChangelinerBL"
                      multiple
                    ></md-file>
                  </md-input-container> -->
                </md-layout>
              </md-layout>
              <md-layout md-gutter v-if="uploadBookingStatus.length > 0">
                <md-layout md-flex="65"></md-layout>
                <md-layout
                  md-flex="20"
                  v-for="(item, index) in uploadBookingStatus"
                  :key="index"
                >
                  <!-- :href="'http://13.229.240.246/LinerBL/'+item" -->
                  <a
                    href="javascript:void(0)"
                    @click="openSignedDocument(`FF_Sea_Export_Uploads/${item}`)"
                    >View Document - {{ index + 1 }}</a
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="30">
                  <label for="billingParty">Billing Party</label>
                  <model-list-select
                    :list="billingPartyList"
                    v-model="billLandingModel.billingParty"
                    option-value="billingPartyVal"
                    option-text="billingPartyTxt"
                    placeholder="Select Billing Party"
                    @input="formalBL(billLandingModel.billingParty)"
                  ></model-list-select>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <label for="billingParty"
                    >Billing Type : <span class="error">*</span></label
                  >
                  <b-form-radio-group
                    v-model="billLandingModel.billingType"
                    :options="billingTypeList"
                    class="mt-3"
                    value-field="BTVal"
                    text-field="BTText"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                  <span class="error" v-if="!billLandingModel.billingType">{{
                    errorVgmList.billingType
                  }}</span>
                </md-layout>
                <md-layout
                  md-flex="30"
                  v-if="billLandingModel.billingParty == 'OthersSpecify'"
                >
                  <md-layout md-flex="100">
                    <label>Other Specify</label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="otherSpecBillingParty"
                      name="otherSpecBillingParty"
                      v-model="billLandingModel.otherSpecBillingParty"
                    ></b-form-input>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label>MBL Date</label><br />
                  <md-layout md-flex="100">
                    <date-picker
                      :style="{ width: '500px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="mbl_date"
                      id="mbl_date"
                      class="mt-2"
                      v-model="billLandingModel.mbl_date"
                    ></date-picker>
                    <span class="error" v-if="billLandingModel.mbl_dateError">
                      {{ billLandingModel.mbl_dateError }}
                    </span>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="50" class="pl-2 pr-2">
                  <label>MBL Release Date</label><br />
                  <md-layout md-flex="100">
                    <date-picker
                      :style="{ width: '500px' }"
                      :format="selectDateFormat"
                      lang="en"
                      name="mbl_release_date"
                      id="mbl_release_date"
                      class="mt-2"
                      v-model="billLandingModel.mbl_release_date"
                    ></date-picker>
                    <span class="error" v-if="billLandingModel.mbl_release_dateError">
                      {{ billLandingModel.mbl_release_dateError }}
                    </span>
                  </md-layout>
                </md-layout>
              </md-layout>
            </div>

            <div
              class="box"
              v-if="FFExport.length > 0 && billLandingModel.typeOfBL == '3'"
            >
              <div class="box-header">
                <label class="box-title">
                  <u>Merge Assignment</u>
                </label>
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="ffContainer" class="table table-striped">
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>FF-Export-FCL No.</th>
                      <th>Place of Receipt</th>
                      <th>Final Place of Delievery</th>

                      <th>Shipping Line</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1, index) in FFExport" :key="index">
                      <td>
                        <md-checkbox
                          :disabled="BLNonData.length > 0 ? true : false"
                          class="md-primary"
                          style="margin: 0px"
                          @change="mergeBLFcl(item1, index)"
                          v-bind:class="
                            mergeFclBLArray.indexOf(item1.ffExportFclId) >= 0
                              ? 'md-checked checkedNew' +
                                item1.ffExportFclId +
                                (index + 1)
                              : 'checkedNew' + item1.ffExportFclId + (index + 1)
                          "
                          :md-value="item1.ffExportFclId"
                          :name="'deptMas' + (item1.ffExportFclId + 1)"
                          :id="'deptMas' + (item1.ffExportFclId + 1)"
                        ></md-checkbox>
                      </td>
                      <td>{{ item1.ffExportFclSeries }}</td>
                      <td>{{ item1.PodLocation }}</td>
                      <td>{{ item1.FpodLocation }}</td>

                      <td>{{ item1.shippingLine }}</td>

                      <!-- <td> 
              <md-button class="md-icon-button md-raised md-dense" @click="viewPoPage(item1.poOrderId)">
  <md-icon>visibility</md-icon>

                      </md-button></td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
            <Multi-Bl
              v-if="
                billLandingModel.ffExportFclId != '' && FreightExportFCL.allModuleId != ''
              "
              :Multi_BL_title="'Multi BL - '"
              :Multi_BL_fk_all_module_id="FreightExportFCL.allModuleId"
              :Multi_BL_jb_series="FreightExportFCL.ffExportFclSeries"
              :Multi_BL_ffExportFclId="billLandingModel.ffExportFclId"
              :Multi_BL_ffExecutionId="billLandingModel.ffExecutionId"
              :Multi_BL_ffBookingId="billLandingModel.ffBookingId"
            />

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="100"> </md-layout>
              <!-- {{btnShow}} -->
              <md-layout md-flex="35">
                <b-button
                  v-if="billLandingModel.blType == 'LinerBL' && doAMS == true"
                  variant="primary"
                  @click="addBLLanding('')"
                  id="addButtonLoader1"
                  >Save & Proceed to AMS Filling</b-button
                >
                <b-button
                  v-else-if="
                    billLandingModel.blType == 'HouseBL' &&
                    (blTableArray.length == 0 || sentAdditionalBL == 2)
                  "
                  variant="primary"
                  @click="addBLLanding('')"
                  id="addButtonLoader1"
                  >Save & Proceed To B/L Draft</b-button
                >
                <b-button
                  v-else-if="
                    blTableArray.length == 0 || sentAdditionalBL == 2 || btnShow == true
                  "
                  variant="primary"
                  @click="addBLLanding('Save')"
                  id="addButtonLoader1"
                  >Save & Submit</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopBL"
      @close="oncloseBL"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseDelete"
      ref="addPopDelete"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

import MultiBl from "../common/multiBl.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/fclBLofLanding");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      btnShow: false,
      blTableArray: [],
      sentAdditionalBL: 0,
      FreightExportFCL: "",
      showMoreNewItem: false,
      visible: true,
      docURL: URL_BASE_DOC,
      isLoading: false,
      FFExport: [],
      blTypeName: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },
        {
          blTypeVal: "LinerBL",
          blTypeTxt: "Liner B/L",
        },
      ],

      billingPartyListName: [
        {
          billingPartyVal: "clientName",
          billingPartyTxt: "Client Name",
        },
        {
          billingPartyVal: "chaName",
          billingPartyTxt: "CHA ",
        },
        {
          billingPartyVal: "OthersSpecify",
          billingPartyTxt: "Others Specify",
        },
      ],

      frghtTermsHblListName: [
        {
          frghtTermsHblVal: "Prepaid",
          frghtTermsHblTxt: "Prepaid",
        },
        {
          frghtTermsHblVal: "Collect",
          frghtTermsHblTxt: "Collect",
        },
      ],
      frghtTermsMblListName: [
        {
          frghtTermsMblVal: "Prepaid",
          frghtTermsMblTxt: "Prepaid",
        },
        {
          frghtTermsMblVal: "Collect",
          frghtTermsMblTxt: "Collect",
        },
      ],
      frghtTermsLinerListName: [
        {
          frghtTermsLinerVal: "Prepaid",
          frghtTermsLinerTxt: "Prepaid",
        },
        {
          frghtTermsLinerVal: "Collect",
          frghtTermsLinerTxt: "Collect",
        },
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      getCLientData: [],
      excelUpload: "",
      ALLMODULE: "",
      JOBSERIES: "",
      containerTypeDetailFactory: ["rwr"],
      finalPlaceUSNONUS: [],
      BLDetailArray: ["rwr"],
      BLListType: [
        {
          type: "Normal B/L",
          val: "1",
        },
        // {
        //   type: "Split B/L",
        //   val: "2"
        // },
        // {
        //   type: "Merge B/L",
        //   val: "3"
        // }
      ],
      billLandingModel: {
        billingType: "",
        typeOfBL: "1",
        blLandingId: "",
        linerBLupload: "",
        linerBLNumber: "",
        blType: "",
        frghtTermsHbl: "",
        frghtTermsMbl: "",
        frghtTermsLiner: "",
        billingParty: "",
        clientId: "",
        clientName: "",
        chaName: "",
        otherSpecBillingParty: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionContainerId: "",
        finalPlaceLocationId: "",
        mbl_date:"",
        mbl_release_date:"",
      },
      doAMS: false,
      errorTermList: {
        frghtTermsHbl: "",
        frghtTermsMbl: "",
      },
      arrayErrorTerm: ["Select Freight Terms for HBL", "Select Freight Terms for MBL"],
      errorLTermList: {
        frghtTermsLiner: "",
        linerBLNumber: "",
      },
      arrayErrorLTerm: ["Select Liner Freight Terms", "Please Enter Master B/L Number"],
      errorVgmList: {
        blType: "",
        billingType: "",
        //  typeOfBL: ""
      },
      arrayErrorVgm: [
        "Select BL Type",
        "Select Billing Type",
        //"Select B/L format"
      ],

      removeVmodel: {
        weighingSlipNo: "",

        containerNo: "",
        containerTypeId: "",
        ffExecutionContainerId: "",
        ffVgmId: "",
      },
      mergeFclBLArray: [],
      vgmArrayList: [],
      CommodityAll: {},
      getCommodityData: ["zim"],
      ALLFclData: ["zim"],

      containerInfo: "",
      getContainerTypeData: ["zim"],
      validate: true,
      portCodeError: "",
      deleteId: "",
      ffExoprtDetail: {
        commodityId: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        commodityType: "",
        itemDescription: "",
      },
      paylod: [
        {
          tableName: "frght_bllanding",
          tableId: "ffExportFclId",
          tableVal: this.$sessionsStorage.get("editExportFCLId"),
        },
        {
          tableName: "fcl_bl_raised",
          tableId: "ffExportFclId",
          tableVal: this.$sessionsStorage.get("editExportFCLId"),
        },
      ],
      paylodUpdate: {
        mergeFclBLArray: [],
        typeOfBL: "",
      },

      BLNonData: [],
      billingTypeList: [
        {
          BTVal: "1",
          BTText: "Local",
          notEnabled: false,
        },
        {
          BTVal: "2",
          BTText: "Overseas",
          notEnabled: false,
        },
        {
          BTVal: "3",
          BTText: "Both",
          notEnabled: false,
        },
      ],
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  watch: {
    billLandingModel: {
      handler: function (newVal, oldVal) {
        if (this.billLandingModel.clientId != "") {
          let clientArray = this.getCLientData.filter((x) => {
            return x.clientId == newVal.clientId;
          });
          this.billLandingModel.clientName = clientArray[0].clientName;
        }

        let array = this.getCLientData.filter((x) => {
          return x.ffExportFclId == newVal.ffExportFclId;
        })[0];
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    DocForm,
    BannerComponent,
    MultiBl,
  },

  computed: {
    uploadBookingStatus() {
      return this.billLandingModel.linerBLupload != ""
        ? this.billLandingModel.linerBLupload.split(",")
        : [];
    },
    blTypeList() {
      return this.blTypeName;
    },
    billingPartyList() {
      return this.billingPartyListName;
    },

    clientList() {
      return this.getCLientData;
    },

    frghtTermsHblList() {
      return this.frghtTermsHblListName;
    },
    frghtTermsMblList() {
      return this.frghtTermsMblListName;
    },
    frghtTermsLinerList() {
      return this.frghtTermsLinerListName;
    },

    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
  },

  methods: {
    sendMANIFESTATION(billLandingModel) {
      if (
        billLandingModel.linerBLNumber == "" ||
        billLandingModel.linerBLNumber == undefined ||
        billLandingModel.linerBLNumber == null
      ) {
        this.alert.content = "Please add First Linear BL Number";
        this.$refs["addPop"].open();
        return false;
      }
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffType", "");
      this.$forceUpdate();
      this.$sessionsStorage.set("sendManifest_ffType", "FF Export");
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", this.ALLMODULE);
      this.$sessionsStorage.set(
        "sendManifest_ffExportFclId",
        this.$sessionsStorage.get("editExportFCLId")
      );
      this.$router.push({
        path: "/freightForwarding/sendManifestation",
      });
    },
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    showMoreItem() {
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },
    proceedToTally() {
      // if (this.containerTypeDetailFactory.length > 0) {
      //   let arrayG = this.containerTypeDetailFactory.filter(x => {
      //     return (
      //       x.LineSealNo == "" ||
      //       x.customSealNo == "" ||
      //       x.grossWeight == "" ||
      //       x.packageId == 0
      //     );
      //   });

      //   if (arrayG.length > 0) {
      //     this.alert.content =
      //       "Please add All Container Details before Proceeding";
      //     this.$refs["addPop6"].open();
      //     return false;
      //   }
      // }

      this.$router.push({
        path: "/freightForward/freightInvoiceForTally?JobType=FF&ShipmentType=Sea&ModuleType="+this.FreightExportFCL.transportType,
      });
    },
    deleteAllBL() {
      this.alert.content =
        "Are you sure you want to delete All  B/L Merged With this assignment ?";
      this.$refs["addPopDelete"].open();
    },
    onCloseDelete(type) {
      if (type != "cancel") {
        $("#DLoader").css("display", "none");
        $("#loaderD").css("display", "block");
        this.paylodUpdate["mergeFclBLArray"] = this.mergeFclBLArray;
        this.paylodUpdate["typeOfBL"] = this.billLandingModel.typeOfBL;
        let newData = {
          paylodUpdate: this.paylodUpdate,
          paylod: this.paylod,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/deleteBLPermanent.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderD").css("display", "none");
              $("#DLoader").css("display", "block");

              if (
                this.containerTypeDetailFactory[0]["stuffingType"] == "factoryStuffing"
              ) {
                this.$router.push({
                  path: "/freightForward/ffExecution",
                });
              } else {
                this.$router.push({
                  path: "/freightForward/ffexecutionWareHouse",
                });
              }
            }
          })
          .catch((error) => {});
      }
    },

    formalBL(item) {
      if (item != undefined && item != null && item != "") {
        this.btnShow = true;
      } else {
        this.btnShow = false;
      }
      this.$forceUpdate();
      // alert(this.btnShow);
    },
    mergeBLFcl(item, index) {
      if (this.mergeFclBLArray.length == 0) {
        this.mergeFclBLArray.push(item.ffExportFclId);
      } else {
        let i = this.mergeFclBLArray.indexOf(item.ffExportFclId);
        if (i >= 0) {
          $(document).ready(function () {
            $(".checkedNew" + item.ffExportFclId + (index + 1)).removeClass("md-checked");
          });
          this.mergeFclBLArray.splice(i, 1);
        } else {
          this.mergeFclBLArray.push(item.ffExportFclId);
        }
      }

      // }
    },
    onFileChangelinerBL() {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", this.$sessionsStorage.get("editExportFCLId"));

        formData.append("staticFileName", "Sea_Export_BILL_OF_LADING_LINERBL");

        formData.append("upload_dir_folderName", "FF_Sea_Export_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          this.billLandingModel.linerBLupload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      this.openSignedDocument(`vgmDetail/${item}`);
    },
    viewEdit(item) {
      let arrayFilter = this.vgmArrayList.filter((x) => {
        return x.ffVgmId == item.ffVgmId;
      });

      Object.keys(this.billLandingModel).map((x) => {
        this.billLandingModel[x] = arrayFilter[0][x] || "";
      });
    },
    oncloseBL() {
      if (this.billLandingModel.blType != "LinerBL") {
        if (this.finalPlaceUSNONUS[0].portLocationType != "USA") {
          this.$router.push({
            path: "/freightForward/BL-NonUS",
          });
        } else {
          this.$router.push({
            path: "/freightForward/BL-US",
          });
        }
      } else if (this.billLandingModel.blType == "LinerBL" && this.doAMS == true) {
        this.$sessionsStorage.set("blType", "liner");
        this.$sessionsStorage.set("ffType", "fclnormal");
        this.$router.push({
          path: "/freightForwarding/amsFilingNormal",
        });
      } else {
        console.log("stop Here");
      }
    },
    getData() {
      this.doLoading();

      let type_Size = {
        itemCode: "itemCode",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToFCLBLLanding.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.stuffingData.length > 0) {
              this.finalPlaceUSNONUS = data.stuffingData;
              this.ALLMODULE = data.stuffingData[0].allModuleId;
              this.JOBSERIES = data.stuffingData[0].ffExportFclSeries;
              // this.billingPartyList[1].billingPartyTxt =
              //   "CHA_" + data.stuffingData[0].ccCha;
              this.containerInfo = data.stuffingData[0].containerInfo;
              this.FreightExportFCL = data.stuffingData[0];
              if (data.stuffingData[0].amsForNonUs == "1") {
                this.doAMS = true;
              } else {
                this.doAMS = false;
              }
              this.sentAdditionalBL = data.stuffingData[0].sentAdditionalBL;
            }
            if (data.ffExecutionDetailContainer.length > 0) {
              this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
            }

            if (data.ffMergeDetail.length > 0) {
              this.FFExport = data.ffMergeDetail;
            }
            if (data.BLNonData.length > 0) {
              this.BLNonData = data.BLNonData;
              this.blTableArray = data.BLNonData;
            }

            if (data.BLData.length > 0) {
              Object.keys(data.BLData[0]).map((x) => {
                this.billLandingModel[x] = data.BLData[0][x] || "";
              });

              if (
                data.BLData[0]["mergeFclExportId"] != "" &&
                data.BLData[0]["mergeFclExportId"] != null
              ) {
                this.mergeFclBLArray = data.BLData[0]["mergeFclExportId"].split(",");
              }
            } else {
              this.billLandingModel.typeOfBL = "1";
            }

            if (data.allClientData.length > 0) {
              this.getCLientData = data.allClientData;
              let arrayNew = this.getCLientData.filter((x) => {
                return x.clientId == data.stuffingData[0].clientId;
              });
              this.billingPartyList[0].billingPartyTxt =
                "Client_" + arrayNew[0].clientName;
            }
            console.log(data);
            if (this.billLandingModel.billingType && this.$sessionsStorage.get("designation") != "Admin" &&
              this.$sessionsStorage.get("nameUser") != "Bhavneesh") {
              this.billingTypeList.forEach((element) => {
                element.notEnabled = true;
              });
            }
            if (data.stuffingData.length > 0) {
              this.billLandingModel.mbl_date=data.stuffingData[0].mbl_date;
              this.billLandingModel.mbl_release_date=data.stuffingData[0].mbl_release_date;
            }
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      window.history.go(-1);

      // if (
      //   this.containerTypeDetailFactory[0]["stuffingType"] == "factoryStuffing"
      // ) {
      //   this.$router.push({
      //     path: "/freightForward/ffExecution"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffexecutionWareHouse"
      //   });
      // }
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;
      if (this.billLandingModel.portName == "") {
        $("#portName").focus();
        this.portNameError = "Enter Port Name";
        validate_new = false;
      }

      if (this.billLandingModel.portCode == "") {
        $("#portCode").focus();
        this.portCodeError = "Enter Port Code ";
        validate_new = false;
      }

      if (this.billLandingModel.portLocation == "") {
        $("#portLocation").focus();
        this.portLocationError = "Enter Port Location ";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.billLandingModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });

      // alert(this.billLandingModel.blType)
      if (this.billLandingModel.blType == "HouseBL") {
        Object.keys(this.errorTermList).map((x, index) => {
          if (this.billLandingModel[x] == "") {
            this.errorTermList[x] = this.arrayErrorTerm[index];
            validate_new = false;
          }
        });
      }

      if (this.billLandingModel.blType == "LinerBL") {
        Object.keys(this.errorLTermList).map((x, index) => {
          if (this.billLandingModel[x] == "") {
            this.errorLTermList[x] = this.arrayErrorLTerm[index];
            validate_new = false;
          }
        });
      }
      if (this.FFExport.length > 0) {
        if (this.mergeFclBLArray == 0 && this.billLandingModel.typeOfBL == "3") {
          this.alert.content = "Please merge atleast 1 assignment";
          this.$refs["addPop6"].open();
          validate_new = false;
        }
      }

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addBLLanding(id) {
      // if (this.billLandingModel.blType == "LinerBL") {
      //   this.billLandingModel.typeOfBL = "";
      // }
      this.$sessionsStorage.set("editfclBlId", "");
      this.billLandingModel["mergeFclBLArray"] = this.mergeFclBLArray;
      this.billLandingModel["allModuleId"] = this.FreightExportFCL.allModuleId;
      this.billLandingModel["JOBNO"] = this.FreightExportFCL.ffExportFclSeries;
      this.validateVGM();

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addFclBLLanding.php`,
          data: JSON.stringify(this.billLandingModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            if (result.data.Id != "" && result.data.Id != undefined) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");
              if (this.billLandingModel.blLandingId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.billLandingModel).map((x) => {
                this.billLandingModel[x] = "";
              });
              if (id == "Save") {
                this.getData();
              }

              this.$refs["addPopBL"].open();
            }
          })
          .catch((error) => {});
      }
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {},
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// fclBLofLanding.vue?398b8529